import React, { PureComponent } from "react";
import { Transition } from "react-transition-group";
import { TweenLite, Back } from "gsap";
import Snackbar from "@material-ui/core/Snackbar";
import axios from "axios";
import Footer from "../../components/footer/Footer";
import "./GameIndex.scss";
import Cookies from "universal-cookie";
import { CAMS_URL, FETCH_URL } from "../../constants/ServerLinks";
import Messages from "../../components/messages/Messages";

const duration = 300;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out, maxHeight ${duration}ms ease-in-out`,
  opacity: 0,
  maxHeight: 0,
  overflow: "hidden",
};

const transitionStyles = {
  entering: { opacity: 0, maxHeight: 0 },
  entered: { opacity: 1, maxHeight: "100%" },
  exiting: { opacity: 1, maxHeight: "100%" },
  exited: { opacity: 0, maxHeight: 0 },
};

export default class GameIndex extends PureComponent {
  constructor() {
    super();

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;
    this.cookies = new Cookies();

    this.state = {
      activeForm: "student",
      snackMsg: "Welcome!",
      snackOpen: false,
      snackType: "snack-success",
      firstName: "",
      lastName: "",
      email: "",
      gameCode: "",
      username: "",
      password: "",
      student_role: "",
      student_team_name: "",
      is_manager: false,
      requestSent: false,
      navLinks: [
        // {
        //   name: "Frank Batten School",
        //   href: "https://batten.virginia.edu",
        //   icon: "iconBatten",
        //   text: "textBatten",
        //   target: "_blank",
        // },
        // {
        //   name: "CLSG",
        //   href: "https://www.clsgbatten.org",
        //   icon: "iconClsg",
        //   text: "textClsg",
        //   target: "_blank",
        // },
        {
          href: "https://dms.academy/",
          icon: "iconDMS",
          target: "_blank",
        },
      ],
      messageDivVisibility: "hidden",
      messageMessage: null,
      messageType: null,
      messageFunction: null,
    };
  }

  handleFocus = (event) => {
    const el = event.target.parentElement;
    const an = el.children[0];

    TweenLite.to(an, 0.1, { y: 0, autoAlpha: 1 });
  };

  handleBlur = (event) => {
    const el = event.target.parentElement;
    const an = el.children[0];

    TweenLite.to(an, 0.075, {
      y: 5,
      autoAlpha: 0,
      ease: Back.linear,
      delay: 0.025,
    });
  };

  handleSnackClose = () => {
    this.setState({ snackOpen: false });
  };

  onChange = (e) => {
    const { name, value } = e.target;

    if (name === "gameCode") {
      if (value.match(/[^a-zA-Z0-9-]/g)) {
        e.target.value = value.replace(/[^a-zA-Z0-9]/g, "");
      }
    }

    this.setState({
      [e.target.name]: e.target.value,
    });

    if (e.target.name === "student_role" && e.target.value === "City Manager") {
      console.log("Congrats you are a city manager!");
      this.setState({
        is_manager: true,
      });
    } else if (
      e.target.name === "student_role" &&
      e.target.value !== "City Manager"
    ) {
      this.setState({
        is_manager: false,
      });
    }
  };

  fetchParticipants = (city_skey) => {
    axios.get(this.fetchURL + "/api/v1/participants/", {
      params: { city_skey: city_skey },
    });
  };

  onStudentJoin = (e) => {
    e.preventDefault();
    this.setState({ requestSent: true });
    axios
      .post(this.fetchURL + "/api/v1/participants/", {
        student_name: this.state.firstName + " " + this.state.lastName,
        student_email: this.state.email,
        game_code: this.state.gameCode,
        is_manager: this.state.is_manager,
        student_role: this.state.student_role,
        student_team_name: "1",
      })
      .then((response) => {
        console.log(response.data);
        this.setState({ requestSent: false });

        if (response.data.success) {
          this.setState({
            snackOpen: true,
            snackMsg: `Authentication successful!`,
            snackType: "snack-success",
          });
          const data = response.data.data;
          this.cookies.set("city_skey", data.city_skey, { maxAge: 86400 });
          this.cookies.set("city_name", data.city_name, { maxAge: 86400 });
          this.cookies.set("p_id", data.id, { maxAge: 86400 });
          this.cookies.set(
            "s_name",
            this.state.firstName + " " + this.state.lastName,
            { maxAge: 86400 }
          );
          this.cookies.set("student_is_manager", data.is_manager, {
            maxAge: 86400,
          });
          this.cookies.set("student_role", data.student_role, {
            maxAge: 86400,
          });
          this.cookies.set("student_team_name", data.student_team_name, {
            maxAge: 86400,
          });
          this.cookies.set("s_email", this.state.email, {
            maxAge: 86400,
          });
          this.cookies.set("game_code", this.state.gameCode, {
            maxAge: 86400,
          });
          this.fetchParticipants(data.city_skey);
          window.location.reload();
        } else {
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: "snack-error",
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          snackOpen: true,
          snackMsg: "Something went wrong. Please try again later.",
          snackType: "snack-error",
        });
        this.setState({ requestSent: false });
      });
  };

  onInstructorLogin = (e) => {
    e.preventDefault();

    this.setState({ requestSent: true });
    axios
      .post(this.camsURL + "/api/auth/login", {
        email: this.state.email,
        password: this.state.password,
      })
      .then((response) => {
        this.setState({ requestSent: false });

        if (response.data.success) {
          this.setState({
            snackOpen: true,
            snackMsg: `Authentication successful!`,
            snackType: "snack-success",
          });
          this.cookies.set("token", response.data.token, { maxAge: 86400 });
          window.location.replace("/instructor");
        } else {
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: "snack-error",
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          snackOpen: true,
          snackMsg: "Something went wrong. Please try again later.",
          snackType: "snack-error",
        });
        this.setState({ requestSent: false });
      });
  };

  // clearCookies = () => {
  //   this.cookies.remove("p_id");
  //   this.cookies.remove("s_name");
  //   this.cookies.remove("city_id");
  //   this.cookies.remove("city_name");
  //   this.cookies.remove("city_skey");
  //   this.cookies.remove("config_number");
  //   this.cookies.remove("role_id");
  //   this.cookies.remove("role_name");
  //   this.cookies.remove("sector_id");
  //   this.cookies.remove("sector_name");
  //   this.cookies.remove("sector_year");
  //   this.cookies.remove("token");
  // };

  messageTemporary = async (time) => {
    // await this.delay(time);
    this.setState({
      messageDivVisibility: "hidden",
      messageMessage: null,
      messageType: null,
      messageFunction: null,
    });
    // await this.delay(time + 1000);
    // this.setState({
    //   messageMessage: null,
    //   messageType: null,
    //   messageFunction: null
    // })
  };

  closeMessage = (e) => {
    e.preventDefault();
    this.messageTemporary(500);
  };

  componentDidMount() {
    var sBrowser,
      sUsrAg = navigator.userAgent;

    // The order matters here, and this may report false positives for unlisted browsers.

    if (sUsrAg.indexOf("Firefox") > -1) {
      sBrowser = "Mozilla Firefox";
      // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
      sBrowser = "Samsung Internet";
      // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
    } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
      sBrowser = "Opera";
      // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    } else if (sUsrAg.indexOf("Trident") > -1) {
      sBrowser = "Microsoft Internet Explorer";
      // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (sUsrAg.indexOf("Edge") > -1) {
      sBrowser = "Microsoft Edge";
      // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    } else if (sUsrAg.indexOf("Chrome") > -1) {
      sBrowser = "Google Chrome or Chromium";
      // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    } else if (sUsrAg.indexOf("Safari") > -1) {
      sBrowser = "Apple Safari";
      // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    } else {
      sBrowser = "unknown";
    }

    console.log(sBrowser);

    if (sBrowser !== "Google Chrome or Chromium") {
      this.setState({
        messageDivVisibility: "visible",
        messageMessage: `Welcome to Metropolitain!  We see that you are using ${sBrowser} as your browser.  Unfortunately this game is currently only compatible with Chrome only.  If you continue with ${sBrowser} the game may not function properly.  Thank you!`,
        messageType: "Warning",
        messageFunction: "Browser",
      });
    }
  }

  render() {
    const student_team_name = [
      { value: "", team: "Select Your Team Assignment" },
      { value: "1", team: "1" },
      { value: "2", team: "2" },
      { value: "3", team: "3" },
      { value: "4", team: "4" },
      { value: "5", team: "5" },
      { value: "6", team: "6" },
      { value: "7", team: "7" },
      { value: "8", team: "8" },
      { value: "9", team: "9" },
      { value: "10", team: "10" },
      { value: "11", team: "11" },
      { value: "12", team: "12" },
      { value: "13", team: "13" },
    ];
    const student_role = [
      {
        value: "",
        role: "Select Your Role",
      },
      {
        value: "City Manager",
        role: "City Manager",
      },
      {
        value: "City Treasurer",
        role: "City Treasurer",
      },
      {
        value: "Transportation Commissioner",
        role: "Transportation Commissioner",
      },
      {
        value: "Health Commissioner",
        role: "Health Commissioner",
      },
      // {
      //   value: "Young People",
      //   role: "Young People"
      // },
      // {
      //   value: "Old People",
      //   role: "Old People"
      // },
      // {
      //   value: "Developers' Assoc.",
      //   role: "Developers' Assoc."
      // },
      // {
      //   value: "Chamber of Commerce",
      //   role: "Chamber of Commerce"
      // },
      {
        value: "Social Services Commissioner",
        role: "Social Services Commissioner",
      },
      // {
      //   value: "Rich Pops",
      //   role: "Rich Pops"
      // },
      // {
      //   value: "Poor Pops",
      //   role: "Poor Pops"
      // },
      // {
      //   value: "Jacobs Hill Prez",
      //   role: "Jacobs Hill Prez"
      // },
      // {
      //   value: "Howard Gardens Prez",
      //   role: "Howard Gardens Prez"
      // },
      // {
      //   value: "Moses Gulch Prez",
      //   role: "Moses Gulch Prez"
      // },
      // {
      //   value: "Corbusville Prez",
      //   role: "Corbusville Prez"
      // },
      // {
      //   value: "Downtown Prez",
      //   role: "Downtown Prez"
      // }
    ];
    return (
      <div className={`${this.props.display === "show" ? "active" : "hidden"}`}>
        <div className="instructorNav flex flex-justify-between">
          <div className="sudoLogo" />
          <div className="metroLogo" />
          <div
            className="familyLogos flex flex-justify-between"
            style={{ flexDirection: "row", marginTop: "20px" }}
          >
            {this.state.navLinks.map((item, index) => (
              <a
                className="flex flex-items-center"
                key={index}
                href={item.href}
                target={item.target}
                style={{ flexDirection: "column" }}
              >
                <span className={item.icon} style={{ marginLeft: "30px" }} />
                <span
                  style={{
                    marginLeft: "30px",
                    fontFamily:
                      'proxima-nova, "Helvetica Neue", Helvetica, Arial, sans-serif',
                    fontSize: ".8vw",
                    fontWeight: 500,
                    fontStyle: "normal",
                    color: "#232d4b",
                  }}
                >
                  {item.name}
                </span>
              </a>
            ))}
          </div>
        </div>

        {/* <div className="persistantBrand flex flex-50-50">
          {this.state.navLinks.map((item, index) => (
            <a key={index} href={item.href} target={item.target}>
              <span className={item.icon}></span>
              <span className={item.text}>{item.name}</span>
            </a>
          ))}
        </div> */}
        {/* <div className="header__padding" /> */}
        <Messages
          messageDivVisibility={this.state.messageDivVisibility}
          messageMessage={this.state.messageMessage}
          messageType={this.state.messageType}
          messageFunction={this.state.messageFunction}
          closeMessage={this.closeMessage}
        />
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={this.state.snackOpen}
          onClose={this.handleSnackClose}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          className={this.state.snackType}
          autoHideDuration={5000}
          message={<span id="message-id">{this.state.snackMsg}</span>}
        />
        <div className="backgroundPic" />
        <div
          className={`flex flex-items-center flex-justify-center`}
          style={{ margin: "0px 20px" }}
        >
          <div className="info__container">
            <h1>Metropolitan</h1>
            <h2>A Sustainable Transit Simulation</h2>
            <p>
              Revitalize your city's transportation infrastructure for a
              sustainable equitable future. Playing as members of city
              government, participants decide on decisions like density, housing
              policies, charging stations, and bus lines.
            </p>
            <br />
            <div className="beta-banner">
              <h4>Early access simulation</h4>
              <p>
                This is a playable, fully functional simulation, but it’s not a
                polished final product. We still have some work to do, and we’d
                love to hear what you and your students think of this early
                version.
              </p>
            </div>

            <br />

            <h3>Policy focus</h3>
            <ul>
              <li>Migration</li>
            </ul>
            <h3>Skills focus</h3>
            <ul>
              <li>Multi-party & bilateral negotiation</li>
              <li>Data Analysis</li>
              <li>Consensus-building</li>
              <li>Trade-offs (long-term vs. short-term)</li>
            </ul>
          </div>

          <div className={`account__container ${this.state.activeForm}-active`}>
            <div
              className={`flex account__switcher ${
                this.state.activeForm
              }-active`}
            >
              <div
                className={`student-btn trigger`}
                onClick={() => {
                  this.setState((state) => ({
                    activeForm: "student",
                  }));
                }}
              >
                Student
              </div>
              <div
                className={`instructor-btn trigger`}
                onClick={() => {
                  this.setState((state) => ({
                    activeForm: "instructor",
                  }));
                }}
              >
                Instructor
              </div>
            </div>

            <div className={`account__wrapper`}>
              <Transition
                in={this.state.activeForm === "student"}
                timeout={300}
                unmountOnExit
              >
                {(state) => (
                  <div
                    style={{
                      ...defaultStyle,
                      ...transitionStyles[state],
                    }}
                  >
                    <h3>Join Using Game Code</h3>
                    <form
                      className="signup_form"
                      method="post"
                      onSubmit={(e) => this.onStudentJoin(e)}
                    >
                      <br />
                      <h4>Student Info</h4>
                      <div className={`flex flex-wrap formRow`}>
                        <div
                          className="formItem"
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                        >
                          <label
                            ref={(a) => (this.labeltest = a)}
                            className="formLabel"
                            htmlFor="firstName"
                          >
                            First Name
                          </label>
                          <input
                            type="text"
                            className={`input__one account__input`}
                            name="firstName"
                            id="firstName"
                            placeholder="Enter your First Name"
                            value={this.state.firstName}
                            onChange={(e) => this.onChange(e)}
                            required
                          />
                        </div>

                        <div
                          className="formItem"
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                        >
                          <label
                            ref={(a) => (this.labeltest = a)}
                            className="formLabel"
                            htmlFor="lastName"
                          >
                            Last Name
                          </label>
                          <input
                            type="text"
                            className={`input__one account__input`}
                            name="lastName"
                            id="lastName"
                            value={this.state.lastName}
                            onChange={(e) => this.onChange(e)}
                            placeholder="Enter your Last Name"
                            required
                          />
                        </div>
                      </div>

                      <div className={`flex flex-wrap formRow`}>
                        <div
                          className="formItemFull"
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                        >
                          <label
                            ref={(a) => (this.labeltest = a)}
                            className="formLabel"
                            htmlFor="email"
                          >
                            Email
                          </label>
                          <input
                            type="email"
                            className={`input__one account__input`}
                            name="email"
                            id="email"
                            value={this.state.email}
                            onChange={(e) => this.onChange(e)}
                            placeholder="Enter your Email"
                            required
                          />
                        </div>
                      </div>
                      <div className={`flex flex-wrap formRow`}>
                        <div
                          className="formItemFull"
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                        >
                          <label
                            ref={(a) => (this.labeltest = a)}
                            className="formLabel"
                            htmlFor="student_role"
                          >
                            Role
                          </label>
                          <select
                            className="studentSelect"
                            name="student_role"
                            value={this.state.student_role}
                            onChange={(e) => this.onChange(e)}
                            id="student_role"
                            required
                          >
                            {student_role.map((item, index) => (
                              <option
                                key={index}
                                value={item.value}
                                name="student_role"
                              >
                                {item.role}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className={`flex flex-wrap formRow`}>
                        <div
                          className="formItemFull"
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                        >
                          <label
                            ref={(a) => (this.labeltest = a)}
                            className="formLabel"
                            htmlFor="student_team_name"
                          >
                            Team Assignment
                          </label>
                          {/* <select
                            className="studentSelect"
                            name="student_team_name"
                            id="student_team_name"
                            value={this.state.student_team_name}
                            onChange={e => this.onChange(e)}
                            required
                          >
                            {student_team_name.map((item, index) => (
                              <option
                                key={index}
                                value={item.value}
                                name="student_team_name"
                              >
                                {item.team}
                              </option>
                            ))}
                          </select> */}
                        </div>
                      </div>

                      <br />
                      <h4>Game Info (Shared by your Instructor)</h4>
                      <div className={`flex flex-wrap formRow`}>
                        <div
                          className="formItemFull"
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                        >
                          <label
                            ref={(a) => (this.labeltest = a)}
                            className="formLabel"
                            htmlFor="gameCode"
                          >
                            Game Code
                          </label>
                          <input
                            type="text"
                            className={`input__one account__input`}
                            name="gameCode"
                            id="gameCode"
                            value={this.state.gameCode}
                            onChange={(e) => this.onChange(e)}
                            placeholder="Game Code"
                            required
                          />
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="loginBtn"
                        disabled={this.state.requestSent ? "disabled" : ""}
                      >
                        {this.state.requestSent ? "Joining . . ." : "Join"}
                      </button>

                      <br />
                      <br />
                      {/* <span className="switchLink" onClick={this.clearCookies}>
                        Clear Cookies
                      </span> */}
                    </form>
                  </div>
                )}
              </Transition>

              <Transition
                in={this.state.activeForm === "instructor"}
                timeout={300}
                unmountOnExit
              >
                {(state) => (
                  <div
                    style={{
                      ...defaultStyle,
                      ...transitionStyles[state],
                    }}
                  >
                    <h3>Sign In to Your Account</h3>
                    <form
                      className="signup_form"
                      method="post"
                      onSubmit={(e) => this.onInstructorLogin(e)}
                    >
                      <br />
                      <h4>Credentials</h4>
                      <div className={`flex flex-wrap formRow`}>
                        <div
                          className="formItemFull"
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                        >
                          <label
                            ref={(a) => (this.labeltest = a)}
                            className="formLabel"
                            htmlFor="username"
                          >
                            Email
                          </label>
                          <input
                            id="email"
                            name="email"
                            className={`input__one account__input`}
                            type="text"
                            value={this.state.email}
                            placeholder="Email"
                            required="required"
                            onChange={(e) => this.onChange(e)}
                          />
                        </div>
                      </div>

                      <div className={`flex flex-wrap formRow`}>
                        <div
                          className="formItemFull"
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                        >
                          <label
                            ref={(a) => (this.labeltest = a)}
                            className="formLabel"
                            htmlFor="password"
                          >
                            Password
                          </label>
                          <input
                            id="password"
                            name="password"
                            type="password"
                            value={this.state.password}
                            placeholder="Password"
                            className={`input__one account__input`}
                            required="required"
                            onChange={(e) => this.onChange(e)}
                          />
                        </div>
                      </div>

                      <button type="submit" className="loginBtn">
                        Login
                      </button>

                      <br />
                      <br />
                      {/* <span className="switchLink" onClick={this.clearCookies}>
                        Clear Cookies
                      </span> */}
                    </form>
                  </div>
                )}
              </Transition>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
